import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export const LoadingSpinner = ({ className, size = 'default' }) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        default: 'w-6 h-6',
        large: 'w-8 h-8'
    };

    return (
        <div className="flex items-center justify-center p-8" data-testid="loading-spinner">
            <Loader2 className={cn('animate-spin text-primary', sizeClasses[size], className)} />
        </div>
    );
};
